// extracted by mini-css-extract-plugin
export var currencyInput = "_nl-1";
export var currencySymbol = "_nl-0";